export enum ToastMessages {
  // Rerun
  RERUN_ERROR = "Something went wrong!",
  RERUN_SUCCESS = "Re-run successful!",

  // Coverage
  COVERAGE_REFRESH_SUCCESS = "Coverage refreshed successfully!",
  COVERAGE_REFRESH_FAILURE = "Coverage refreshing failed!",
  COVERAGE_SAVE_SUCCESS = "Coverage saved successfully!",
  COVERAGE_SAVE_FAILURE = "Failed to save coverage. Please try again.",
  COVERAGE_SAVE_VALIDATION_FAILURE = "Fill in all required fields before saving.",
  COVERAGE_CONTINUE_VALIDATION_FAILURE = "Fill in all required fields before continuing.",
  COVERAGE_SAVE_VALIDATION_USED_EXCEEDS_TOTAL = "Used amount cannot exceed the total amount.",
  COVERAGE_SAVE_VALIDATION_PLAN_END_DATE = "Plan end date must be greater than effective date.",
  COVERAGE_SAVE_VALIDATION_PLAN_END_AFTER_DOS = "Plan end date must be on or after the date of service for active coverage.",
  COVERAGE_SAVE_VALIDATION_PLAN_END_BEFORE_DOS = "Plan end date must be strictly before the date of service for inactive coverage.",
  COVERAGE_SAVE_VALIDATION_CO_INSURANCE_MAX = "Co-Insurance cannot exceed 100%.",

  // Patient Responsibility
  PR_SUCCESS = "Patient Responsibility calculated!",
  PR_FAILURE = "Patient Responsibility calculation failed!",

  // CMM Insurance
  CMM_INSURANCE_SAVE_SUCCESS = "Insurance details saved successfully!",
  CMM_INSURANCE_SAVE_FAILURE = "Insurance details save failed!",

  // Form
  FORM_SAVE_SUCCESS = "Form Details saved successfully!",
  FORM_SAVE_FAILURE = "Form Details save failed!",
  FORM_DETAILS_SAVE_SUCCESS = "Form details saved successfully!",
  FORM_DETAILS_SAVE_FAILURE = "Error saving form details. Please try again.",

  // Submission
  SUBMISSION_INITIATED_SUCCESS = "Submission initiated!",
  SUBMISSION_INITIATED_FAILURE = "Submission initiation failed!",

  // Clipboard
  KEY_COPY_SUCCESS = "Copied to clipboard",

  // Status
  STATUS_CHANGED_SUCCESS = "Status updated successfully!",
  STATUS_CHANGED_FAILURE = "Status update failed!",
  STATUS_UPDATE_SUCCESS = "Status update successful",
  STATUS_UPDATE_ERROR = "Error updating status. Please try again.",

  // Assignee
  ASSIGNEE_CHANGED_SUCCESS = "Assignee updated successfully!",
  ASSIGNEE_CHANGED_FAILURE = "Assignee update failed!",

  // File Upload
  DUPLICATE_FILE_UPLOAD = "Cannot upload duplicate file!",
  FILE_UPLOAD_SUCCESS = "File uploaded successfully!",
  FILE_UPLOAD_FAILURE = "Error uploading file. Please try again.",

  // Send to Plan
  SEND_TO_PLAN_SUCCESS = "Send to plan successful!",

  // Eligibility
  CHECK_ELIGIBILITY_FAILURE = "Unable to check eligibility!",
  CHECK_ELIGIBILITY_SUCCESS = "Eligibility checked successfully!",
  RE_RUNNING_ELIGIBILITY_CHECK = "Re-running eligibility check.",

  // Claims
  CHECK_CLAIMS_FAILURE = "Claims processing failed!",
  CHECK_CLAIMS_SUCCESS = "Claims processed successfully!",

  // Email Verification
  EMAIL_VERIFICATION_FAILED = "Please verify your email before logging in. A new verification email has been sent.",
  EMAIL_VERIFICATION_SUCCESS = "Please verify your email before logging in. A new verification email has been sent.",

  // Login/Auth
  INVALID_EMAIL_OR_PASSWORD = "Email or password is incorrect. Please try again.",
  EMAIL_SENT = "Password reset link sent to your email",
  EMAIL_SENT_ERROR = "Could not send the email. Please try resending",
  SIGN_UP_ERROR = "Failed to sign up. Please try again.",
  LOGIN_ERROR = "Failed to login. Please try again.",

  // MFA
  MFA_SETUP_ERROR = "Error setting up MFA. Please try again.",
  MFA_SETUP_SUCCESS = "MFA setup successfully for the user!",
  MFA_SUCCESS = "MFA verification successful!",
  MFA_VERIFICATION_ERROR = "MFA verification failed. Please try again.",

  // Re-run from EMR/CMM
  RE_RUN_SUCCESS_ONCO_EMR = "Re-run started successfully from Onco EMR!",
  RE_RUN_SUCCESS_CMM = "Re-run started successfully from CMM!",

  // Inaccuracy
  INACCURACY_REPORTED_SUCCESS = "Inaccuracy Reported Successfully!",
  INACCURACY_REPORTED_FAILURE = "Error reporting inaccuracy. Please try again.",

  // EVBV Status
  EVBV_STATUS_UPDATED_SUCCESS = "Evbv Status Updated Successfully!",
  EVBV_STATUS_UPDATED_FAILURE = "Error updating evbv status. Please try again.",

  // Auth on File
  AUTH_ON_FILE_REFRESHED_SUCCESS = "Auth on file refresh initiated!",
  AUTH_ON_FILE_REFRESHED_FAILURE = "Error refreshing auth on file. Please try again.",

  // Password Reset
  PASSWORD_RESET_SUCCESS = "Password updated successfully!",
  PASSWORD_RESET_FAILURE = "Error in updating password.",

  // Validator
  VALIDATOR_RUN_INITIATED = "Validator run initiated!",
  VALIDATOR_RUN_INITIATED_FAILURE = "Error in initiating validator run.",

  // SIG Box Note
  SIG_BOX_NOTE_UPDATED_SUCCESS = "SIG box note update initiated successfully!",
  SIG_BOX_NOTE_UPDATED_FAILURE = "Error in updating SIG box note.",

  // Version Deploy
  VERSION_DEPLOY_SUCCESS = "Version deployed successfully!",
  VERSION_DEPLOY_ERROR = "Could not deploy version. Please try again.",

  // Form Submission
  FORM_SUBMISSION_FAILURE = "Error in submitting form. Please try again.",
  FORM_SUBMISSION_SUCCESS = "Form submission initiated!",

  // Form Config
  FORM_CONFIG_SAVE_FAILURE = "Error saving form config. Please try again.",
  FORM_CONFIG_SAVE_SUCCESS = "Form config saved successfully!",
  FORM_CONFIGURATION_UPDATE_SUCCESS = "Form configuration updated successfully!",
  FORM_CONFIGURATION_UPDATE_FAILURE = "Error updating form configuration. Please try again.",
  FORM_CONFIGURATION_NOT_AVAILABLE = "Form configuration error",

  // Sent to Plan Configuration
  SENT_TO_PLAN_CONFIGURATION_UPDATE_SUCCESS = "Sent to plan configuration updated successfully!",
  SENT_TO_PLAN_CONFIGURATION_UPDATE_FAILURE = "Error updating sent to plan configuration. Please try again.",

  // PBM Config
  PBM_CONFIG_SAVE_SUCCESS = "PBM configuration saved successfully!",
  PBM_CONFIG_SAVE_ERROR = "Error saving PBM configuration. Please try again.",

  // Drug
  DRUG_NAME_ALREADY_EXISTS = "Drug already exists!",
  DRUG_NAME_ADDED_SUCCESSFULLY = "New Drug added successfully!",
  DRUG_NAME_ADD_FAILURE = "Error adding drug name. Please try again.",
  DRUG_NAME_ERROR = "Please enter a drug name",
  DRUG_LABEL_ERROR = "Error fetching drug label. Please try again.",
  DRUG_LABEL_SUCCESS = "Drug label fetched successfully",

  // Parsed Insurance Card
  PARSED_INSURANCE_CARD_SAVE_SUCCESS = "Parsed insurance card saved successfully!",
  PARSED_INSURANCE_CARD_SAVE_FAILURE = "Error saving parsed insurance card. Please try again.",

  // Credential
  CREDENTIAL_SAVE_SUCCESS = "Credential saved successfully!",
  CREDENTIAL_SAVE_ERROR = "Error saving credential. Please try again.",

  // Invitation
  INVITATION_SUCCESS = "Invitation sent successfully!",
  INVITATION_FAILURE = "Error sending invitation. Please try again.",

  // Medicine Name Configuration
  MEDICINE_NAME_DEPLOY_SUCCESS = "Medicine name configuration deployed successfully!",
  MEDICINE_NAME_DEPLOY_ERROR = "Error deploying medicine name configuration. Please try again.",
  MEDICINE_NAME_DEPLOY_NO_VERSION = "Please select a version to deploy.",
  MEDICINE_NAME_TEST_NO_MRN = "Please enter MRN to test.",
  MEDICINE_NAME_TEST_NO_IDENTIFIER = "Please enter identifier to test.",
  MEDICINE_NAME_TEST_NO_OPTIONS = "Please enter medicine options to test.",
  MEDICINE_NAME_TEST_NO_VERSION = "Please select a version for testing.",
  MEDICINE_NAME_TEST_SUCCESS = "Medicine name configuration tested successfully!",
  MEDICINE_NAME_TEST_ERROR = "Error testing medicine name configuration. Please try again.",
  MEDICINE_NAME_CONFIG_REFRESHED = "Medicine name configuration refreshed successfully!",
  MEDICINE_NAME_CONFIG_REFRESH_ERROR = "Error refreshing medicine name configuration. Please try again.",
  MEDICINE_NAME_CONFIG_VERSION_SAVED = "Medicine name configuration version saved successfully!",
  MEDICINE_NAME_CONFIG_SAVE_ERROR = "Error saving medicine name configuration version. Please try again.",

  // Facility
  FACILITY_ADDED_SUCCESS = "Facility added successfully!",
  FACILITY_ADDED_FAILURE = "Error adding facility. Please try again.",
  FACILITY_UPDATED_SUCCESS = "Facility updated successfully!",
  FACILITY_UPDATED_FAILURE = "Error updating facility. Please try again.",

  // ICD Code
  ICD_CODE_DETERMINATION_SUCCESS = "ICD code determined successfully!",
  ICD_CODE_DETERMINATION_FAILURE = "Error determining ICD code. Please try again.",
  ICD_INSTRUCTIONS_UPDATED_SUCCESSFULLY = "ICD instructions updated successfully!",
  ICD_10_SAVED_SUCCESSFULLY = "New Primary ICD-10 code saved successfully!",

  // Excel Export
  EXCEL_EXPORTED_SUCCESSFULLY = "Excel file exported successfully!",
  ERROR_EXPORTING_DATA = "Error exporting data. Please try again.",

  // Date Selection
  PLEASE_SELECT_A_DATE = "Please select a date first",
  PLEASE_SELECT_BOTH_START_AND_END_DATES = "Please select both start and end dates",

  // Diff Data
  NO_DIFF_DATA_AVAILABLE = "No diff data available",
  NO_DIFF_DATA_AVAILABLE_FOR_SELECTED_DATE = "No diff data available for selected date",

  // Clinical Attachment
  CLINICAL_ATTACHMENT_REFETCHED_SUCCESS = "Clinical attachment refetched successfully",
  CLINICAL_ATTACHMENT_REFETCHED_FAILURE = "Error refetching clinical attachment. Please try again.",

  // CSV Processing
  CSV_PROCESSING_SUCCESS = "CSV processing initiated successfully!",
  CSV_PROCESSING_FAILURE = "Error processing CSV. Please try again.",

  // Analytics
  ERROR_ANALYTICS = "Error fetching analytics data. Please try again.",

  // Email Link
  EMAIL_LINK_SENT_SUCCESS = "Link sent via email successfully!",
  EMAIL_LINK_SENT_FAILURE = "Error sending link via email. Please try again.",

  // CPT Codes
  CPT_CODES_UPDATED_SUCCESS = "CPT codes updated successfully!",
  CPT_CODES_UPDATED_FAILURE = "Error updating CPT codes. Please try again.",

  // Related Drugs
  RELATED_DRUGS_ADDED_SUCCESS = "Related drugs Updated successfully!",

  // PDF
  REFRESH_PDF_SUCCESS = "Fetching PDF. Please come back after a few minutes",
  REFRESH_PDF_FAILURE = "Error refreshing PDF. Please try again.",
  MERGE_PDFS_SUCCESS = "PDFs merged successfully!",
  MERGE_PDFS_ERROR = "Failed to merge PDFs. Please try again.",

  // Order Assignment
  ASSIGN_ORDER_SUCCESS = "Order assigned successfully!",
  ASSIGN_ORDER_FAILED = "Error assigning order. Please try again.",

  // Order Push
  ORDER_PUSHED_SUCCESS = "Orders pushed successfully!",
  ORDER_PUSHED_FAILURE = "Error pushing orders. Please try again.",

  // Payer ID Check
  PAYER_ID_CHECK_SUCCESS = "Availity payer ID check completed successfully",
  PAYER_ID_CHECK_FAILED = "Availity payer ID check failed",

  // NAR Letter
  NAR_LETTER_UPLOADED = "Document uploaded successfully",
  NAR_LETTER_UPLOAD_ERROR = "Error uploading NAR letter. Please try again.",

  // Mark as Completed Trial
  MARK_AS_COMPLETED_TRIAL_UPDATED = "Mark as completed trial updated successfully",
  MARK_AS_COMPLETED_TRIAL_UPDATED_ERROR = "Error updating mark as completed trial. Please try again.",

  // Documents
  DOCUMENTS_UPDATED_SUCCESS = "Documents updated successfully",
  DOCUMENTS_UPDATED_ERROR = "Error updating documents. Please try again.",

  // Retry
  RETRY_ERROR = "Please retry after 10 seconds",

  // Status Log
  STATUS_LOG_SAVED = "Status log saved successfully",
  STATUS_LOG_SAVE_FAILURE = "Error saving status log. Please try again.",

  // Document Uploaded Manually
  DOCUMENT_UPLOADED_MANUALLY_ONCOEMR = "Please upload & save the document uploaded manually on OncoEMR ",

  // Mark as Completed
  MARK_AS_COMPLETED_SUCCESS = "Marked as completed successfully.",
  MARK_AS_COMPLETED_ERROR = "Error while marking as completed. Please try again.",

  // Hold
  HOLD_SAVED_SUCCESS = "Date of hold until has been recorded successfully",
  HOLD_SAVE_ERROR = "Error while saving hold. Please try again.",

  // NAR Grid
  NAR_GRID_NOT_AVAILABLE = "NAR Grid is not available for this order",

  // RPA Trigger
  NAR_RPA_TRIGGER_SUCCESS = "RPA Trigger successful",
  NAR_RPA_TRIGGER_ERROR = "Error in triggering RPA. Please try again.",

  // Candid Writeback
  CANDID_WRITEBACK_INITIATED = "Candid Writeback Initiated",
  CANDID_WRITEBACK_ERROR = "Failed to initiate Candid Writeback",

  // Primary Diagnosis Code
  PRIMARY_DIAGNOSIS_CODE_UPDATED_SUCCESS = "Primary diagnosis code updated successfully!",
  PRIMARY_DIAGNOSIS_CODE_UPDATED_ERROR = "Error updating primary diagnosis code. Please try again.",

  // Dx Code
  DX_CODE_ERROR = "Please enter a valid Dx Code",
  DX_CODE_MAPPING_FETCH_FAILURE = "Error fetching Dx Code Mapping. Please try again.",

  // Auth Grid
  AUTH_GRID_SUCCESS = "Auth Grid fetched successfully!",
  AUTH_GRID_FAILURE = "Error fetching auth grid. Please try again.",
  AUTH_GRID_NO_DATA = "No data found for the selected criteria.",

  // Kill Switch
  KILL_SWITCH_SUCCESS = "Kill switch has been toggled",
  KILL_SWITCH_FAILURE = "Error toggling kill switch. Please try again.",

  // Orders Selection
  NO_ORDERS_SELECTED = "No orders selected",

  // Refetch PA Order
  REFETCH_PA_ORDER_SUCCESS = "PA orders refetched successfully",
  REFETCH_PA_ORDER_ERROR = "Error refetching PA order. Please try again.",

  // Fax
  ERROR_GETTING_FAX_STATUS = "Error getting fax status. Please try again.",
  FAX_ID_NOT_FOUND = "Fax ID not found",
  ORGANISATION_ID_NOT_FOUND = "Organisation ID not found",
  ERROR_SENDING_FAX = "Error sending fax. Please try again.",

  // NAR CSV
  NAR_CSV_DOWNLOAD_SUCCESS = "CSV downloaded successfully!",
  NAR_CSV_DOWNLOAD_FAILURE = "Error downloading CSV. Please try again.",

  // NAR Ingestion
  NAR_INGESTION_SUCCESS = "NAR grid ingestion initiated successfully!",
  NAR_INGESTION_FAILURE = "Error ingesting NAR grid. Please try again.",
  NAR_INGESTION_VALIDATION_ERROR = "Please fill in all required fields.",
  NAR_INGESTION_FILE_UPLOADED_SUCCESS = "File uploaded successfully!",
  NAR_INGESTION_APPROVED_SUCCESS = "NAR ingestion approved successfully!",
  NAR_INGESTION_APPROVED_FAILURE = "Error approving NAR ingestion. Please try again.",
  NAR_INGESTION_REJECTED_SUCCESS = "NAR ingestion rejected successfully!",
  NAR_INGESTION_REJECTED_FAILURE = "Error rejecting NAR ingestion. Please try again.",
  NAR_INGESTION_INSURANCE_ERROR = "Please select the insurance.",
  NAR_INGESTION_PLAN_ERROR = "Please select the plan.",
  NAR_INGESTION_DATE_ERROR = "Please select the date.",
  NAR_INGESTION_PAGE_RANGE_ERROR = "Enter a valid start and end page for the PDF (end page must be >= start page).",
  NAR_INGESTION_FILE_ERROR = "Please upload the file.",
  NAR_INGESTION_FILE_REUPLOADED_SUCCESS = "NAR ingestion document re-uploaded successfully!",

  // BO Notes
  BO_NOTES_SAVED_SUCCESS = "BO notes saved successfully",
  BO_NOTES_SAVED_FAILURE = "Error saving BO notes. Please try again.",

  // Comments writeback validation
  WRITEBACK_VALIDATION_ERROR = "Error validating writeback comments. Proceeding anyway.",

  // No Changes
  NO_CHANGES_TO_SAVE = "No changes to save",

  // Drug Config
  DRUG_CONFIG_UPDATED_SUCCESSFULLY = "Drug configuration updated successfully!",
  DRUG_CONFIG_UPDATE_FAILURE = "Error updating drug configuration. Please try again.",
  PLEASE_FILL_ALL_FIELDS = "Please fill all required fields",

  // Final Worklist
  FOLDER_CREATION_FAILURE = "Error creating folder. Please try again.",
  FINAL_WORKLIST_UPLOAD_SUCCESS = "Final worklist uploaded successfully!",

  // Provider List
  PROVIDER_LIST_DOWNLOAD_ERROR = "Error downloading provider list. Please try again.",
  PROVIDER_LIST_UPLOAD_SUCCESS = "Provider list uploaded successfully!",

  // Prescription Parsing
  PRESCRIPTION_PARSING_TEST_NO_REQUEST_BODY = "Please enter MRN and identifier to test.",
  PRESCRIPTION_PARSING_TEST_NO_VERSION = "Please select a version for testing.",
  PRESCRIPTION_PARSING_TEST_SUCCESS = "Prescription parsing tested successfully!",
  PRESCRIPTION_PARSING_TEST_ERROR = "Error testing prescription parsing. Please try again.",
  PRESCRIPTION_PARSING_DEPLOY_NO_VERSION = "Please select a version to deploy.",
  PRESCRIPTION_PARSING_DEPLOY_VERSIONS_SUCCESS = "Prescription parsing versions deployed successfully!",
  PRESCRIPTION_PARSING_DEPLOY_ERROR = "Error deploying prescription parsing. Please try again.",
  PRESCRIPTION_PARSING_CONFIG_REFRESH_SUCCESS = "Prescription parsing configuration refreshed successfully!",
  PRESCRIPTION_PARSING_CONFIG_REFRESH_ERROR = "Error refreshing prescription parsing configuration. Please try again.",
  PRESCRIPTION_PARSING_CONFIG_NO_CHANGES = "No changes to save",
  PRESCRIPTION_PARSING_CONFIG_SAVE_SUCCESS = "Prescription parsing configuration saved successfully!",
  PRESCRIPTION_PARSING_CONFIG_SAVE_ERROR = "Error saving prescription parsing configuration. Please try again.",
  PRESCRIPTION_PARSING_CONFIG_ITEM_ADDED = "Item added successfully!",
  PRESCRIPTION_PARSING_CONFIG_ITEM_ADD_ERROR = "Error adding item. Please try again.",
  PRESCRIPTION_PARSING_CONFIG_ITEM_DELETED = "Item deleted successfully!",
  PRESCRIPTION_PARSING_CONFIG_ITEM_DELETE_ERROR = "Error deleting item. Please try again.",

  // PA Form Config
  PA_FORM_TEST_NO_REQUEST_BODY = "Please enter MRN and identifier to test.",
  PA_FORM_TEST_NO_VERSION = "Please select a version for testing.",
  PA_FORM_TEST_SUCCESS = "PA form configuration tested successfully!",
  PA_FORM_TEST_ERROR = "Error testing PA form configuration. Please try again.",
  PA_FORM_DEPLOY_NO_VERSION = "Please select a version to deploy.",
  PA_FORM_DEPLOY_SUCCESS = "PA form configuration deployed successfully!",
  PA_FORM_DEPLOY_ERROR = "Error deploying PA form configuration. Please try again.",
  PA_FORM_CONFIG_REFRESHED = "PA form configuration refreshed successfully!",
  PA_FORM_CONFIG_REFRESH_ERROR = "Error refreshing PA form configuration. Please try again.",
  PA_FORM_CONFIG_VERSION_SAVED = "PA form configuration version saved successfully!",
  PA_FORM_CONFIG_SAVE_ERROR = "Error saving PA form configuration. Please try again.",
  PA_FORM_CONFIG_ITEM_STAGED = "Item staged for addition successfully!",
  PA_FORM_CONFIG_ITEM_ADD_ERROR = "Error staging item addition. Please try again.",
  PA_FORM_CONFIG_ITEM_STAGED_DELETE = "Item staged for deletion successfully!",
  PA_FORM_CONFIG_ITEM_DELETE_ERROR = "Error staging item deletion. Please try again.",
  PA_FORM_CONFIG_CATEGORY_STAGED = "Category staged for addition successfully!",
  PA_FORM_CONFIG_CATEGORY_ADD_ERROR = "Error staging category addition. Please try again.",
  PA_FORM_CONFIG_CATEGORY_STAGED_DELETE = "Category staged for deletion successfully!",
  PA_FORM_CONFIG_CATEGORY_DELETE_ERROR = "Error staging category deletion. Please try again.",
  PA_FORM_CONFIG_PBM_STAGED = "PBM staged for addition successfully!",
  PA_FORM_CONFIG_PBM_ADD_ERROR = "Error staging PBM addition. Please try again.",

  // Fax
  FAX_SUBMISSION_FAILURE = "Error submitting fax. Please try again.",
  ORDER_ID_NOT_FOUND = "Order ID not found",
  FAX_STATUS_REFRESHED_SUCCESSFULLY = "Fax status refreshed successfully!",

  // Download
  DOWNLOAD_SUCCESS = "Download successful!",
  DOWNLOAD_FAILURE = "Error downloading. Please try again.",

  // Profile
  PROFILE_UPDATE_SUCCESS = "Profile updated successfully!",
  PROFILE_UPDATE_ERROR = "Error updating profile. Please try again.",

  // Members
  MEMBER_INVITE_SUCCESS = "Member invited successfully!",
  MEMBER_INVITE_FAILED = "Error inviting member. Please try again.",
  MEMBER_REMOVED_SUCCESS = "Member removed successfully!",
  MEMBER_REMOVED_FAILED = "Error removing member. Please try again.",
  MEMBER_REINVITE_SUCCESS = "Member re-invited successfully!",
  MEMBER_REINVITE_FAILED = "Error re-inviting member. Please try again.",

  // Clinical Questionnaire
  CLINICAL_QUESTIONNAIRE_DETERMINATION_SUCCESS = "Clinical questionnaire determined successfully!",
  CLINICAL_QUESTIONNAIRE_DETERMINATION_FAILURE = "Error determining clinical questionnaire. Please try again.",

  // Final Status
  ASSIGN_FINAL_STATUS_SUCCESS = "Final status assigned successfully!",
  ASSIGN_FINAL_STATUS_FAILED = "Error assigning final status. Please try again.",

  // Auth Status
  AUTH_STATUS_UPDATED_FAILURE = "Error updating auth status. Please try again.",

  // Refetch PA Order Partial
  REFETCH_PA_ORDER_PARTIAL_SUCCESS = "Some PA orders refetched successfully",

  // Auth Grid Error
  AUTH_GRID_ERROR = "Error fetching auth grid. Please try again.",

  // RPA Configuration
  VERSION_CREATE_SUCCESS = "Version created successfully!",
  VERSION_CREATE_ERROR = "Error creating version. Please try again.",
  EDIT_SUCCESS = "Changes saved successfully!",
  EDIT_ERROR = "Error saving changes. Please try again.",
  DELETE_SUCCESS = "Deleted successfully!",
  DELETE_ERROR = "Error deleting. Please try again.",
  SWAP_SUCCESS = "Steps swapped successfully!",
  SWAP_ERROR = "Error swapping steps. Please try again.",
  ADD_SUCCESS = "Added successfully!",
  ADD_ERROR = "Error adding. Please try again.",

  // Upload
  UPLOAD_SUCCESS = "Upload successful!",
  UPLOAD_ERROR = "Error uploading. Please try again.",

  ONCO_EMR_BASE_URL_NOT_FOUND = "Onco EMR base URL not found",
  REFRESH_TEMPLATES_SUCCESS = "Templates refreshed successfully",
  // Status
  REFRESH_TEMPLATES_FAILURE = "Error refreshing templates. Please try again.",

  // Email Password Configuration
  EMAIL_PASSWORD_SAVE_SUCCESS = "Email password saved successfully!",
  EMAIL_PASSWORD_SAVE_ERROR = "Error saving email password. Please try again.",
  VIEW_PASSWORD_ERROR = "Error viewing password. Please try again.",
  MEMBER_ROLE_UPDATE_FAILED = "Error updating member role. Please try again.",
  MEMBER_ROLE_UPDATE_SUCCESS = "Member role updated successfully!",
  USER_STATUS_UPDATE_SUCCESS = "User status updated successfully!",
  USER_STATUS_UPDATE_FAILED = "Error updating user status. Please try again.",
  USER_ACCESS_UPDATE_SUCCESS = "User access updated successfully!",
  USER_ACCESS_UPDATE_FAILED = "Error updating user access. Please try again.",

  // Data Migration
  DATA_MIGRATION_SUCCESS = "Data migration completed successfully!",
  DATA_MIGRATION_FAILURE = "Error migrating data. Please try again!",

  // Document Title
  DOCUMENT_TITLE_UPDATED_SUCCESS = "Document title updated successfully!",
  DOCUMENT_TITLE_UPDATED_ERROR = "Error updating document title. Please try again.",

  // Options Configuration
  OPTION_ADD_SUCCESS = "Option added successfully!",
  OPTION_ADD_ERROR = "Failed to add option. Please try again.",
  OPTION_EDIT_SUCCESS = "Option edited successfully!",
  OPTION_EDIT_ERROR = "Failed to edit option. Please try again.",
  OPTION_DELETE_SUCCESS = "Option deleted successfully!",
  OPTION_DELETE_ERROR = "Failed to delete option. Please try again.",
  OPTION_COPY_SUCCESS = "Options copied from organization successfully!",
  OPTION_COPY_ERROR = "Failed to copy options. Please try again.",
  OPTION_REORDER_SAVE_SUCCESS = "Options order saved successfully!",
  OPTION_REORDER_SAVE_ERROR = "Failed to save options order. Please try again.",
  OPTION_SAVE_ALL_SUCCESS = "All changes saved successfully!",
  OPTION_SAVE_ALL_ERROR = "Failed to save changes. Please try again.",

  // Status Update
  AUTH_STATUS_CHANGE_REASONS_SAVED = "Auth status change reasons saved successfully",
  AUTH_STATUS_CHANGE_REASONS_SAVE_ERROR = "Error saving auth status change reasons. Please try again.",

  // Clinical Attachment
  CLINICAL_ATTACHMENT_UPLOADED_SUCCESS = "Clinical attachment uploaded successfully",
  CLINICAL_ATTACHMENT_UPLOADED_ERROR = "Error uploading clinical attachment. Please try again.",

  // Questionnaire
  QUESTIONNAIRE_UPDATED_SUCCESS = "Questionnaire updated successfully!",
  QUESTIONNAIRE_UPDATED_ERROR = "Error updating questionnaire. Please try again.",
  // DX Code Config
  DX_CODE_CONFIG_SAVE_SUCCESS = "DX code configuration saved successfully!",
  DX_CODE_CONFIG_SAVE_ERROR = "Error saving DX code configuration. Please try again.",
  DX_CODE_CONFIG_CREATE_SUCCESS = "DX code configuration created successfully!",
  DX_CODE_CONFIG_CREATE_ERROR = "Error creating DX code configuration. Please try again.",
  DX_CODE_CONFIG_SELECT_PREVIOUS_REQUIRED = "Please select a previous configuration to copy from.",
  DX_CODE_CONFIG_PREVIOUS_NOT_FOUND = "Selected previous configuration was not found. Please refresh and try again.",
  DX_CODE_CONFIG_J_CODE_REQUIRED = "Please enter a J code.",
  DX_CODE_CONFIG_REGIMEN_DETAILS_REQUIRED = "Please enter both regimen code and regimen name.",
  DX_CODE_ADDED_SUCCESS = "DX code added to list.",
  DX_CODE_DELETED_SUCCESS = "DX code deleted from list.",
  DX_CODE_DUPLICATE_ERROR = "DX code already exists in the list.",

  // Order Review (Review Modal)
  REVIEW_SUBMITTED_SUCCESSFULLY = "Review submitted successfully",
  ERROR_UPDATING_ORDER_REVIEW_STATUS = "Error updating order review status. Please try again.",

  // J Code
  CPT_CODE_ADDED_SUCCESSFULLY = "CPT code added successfully.",
  CPT_CODE_ADD_FAILED = "Error adding CPT code. Please try again.",
  CPT_CODE_DELETED_SUCCESS = "CPT code deleted successfully.",
  CPT_CODE_DELETED_ERROR = "Error deleting CPT code. Please try again.",

  // Order Status
  ORDER_STATUS_UPDATED_SUCCESS = "Order status updated successfully.",
  ORDER_STATUS_UPDATED_FAILED = "Error updating order status. Please try again.",
  // OncoEMR Tasks
  TASK_CREATE_SUCCESS = "Task created successfully!",
  TASK_CREATE_FAILURE = "Failed to create task. Please try again.",
  TASK_CREATE_MISSING_CONTEXT = "Order context is not loaded. Please refresh and try again.",
  TASK_REPLY_FAILURE = "Failed to send message. Please try again.",
  TASK_REPLY_MISSING_CONTEXT = "Task context is not loaded. Please refresh and try again.",
  TASK_REPLY_RETRY_FAILURE = "Failed to retry message. Please try again.",
  TASK_REPLY_RETRY_MISSING_CONTEXT = "Task context is not loaded. Please refresh and try again.",
}
